import { IFreeGamesAutoPlayState } from '@GFTypes/GameStoreTypes/SpinParameters';

export const FREEGAMES_AUTOPLAY_STATE_DEFAULTS: IFreeGamesAutoPlayState = {
    isEnabled: false,
    currentCount: 0,
    totalCount: 0,
    lossLimit: 0,
    delayBeforeSpin: 0,
    isSuspended: false
};
